import { render, staticRenderFns } from "./beamWarpingDetalis.vue?vue&type=template&id=6856a710&scoped=true&"
import script from "./beamWarpingDetalis.vue?vue&type=script&lang=js&"
export * from "./beamWarpingDetalis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6856a710",
  null
  
)

export default component.exports